import "./CartSubtitle.css";

interface CartSubtitleProps {
  text: string;
  opacity?: number;
  margin?: string;
}

export const CartSubtitle = ({ text, margin, opacity }: CartSubtitleProps) => {
  const styles = {
    margin: margin || "0",
    opacity: opacity || 1,
  };

  return (
    <p className="card-subtitle" style={styles}>
      {text}
    </p>
  );
};
